module.exports = __webpack_public_path__ + "img/img-bg-color-s3.a2c83826.jpg";